import { Box, Button, Grid } from "@mui/material";
import styled from '@emotion/styled';
import { KeyboardArrowDown } from "@mui/icons-material";
export const Wrapper = styled.div`
  min-height: 100vh;
  padding-top: 40px;
  padding-bottom: 60px;
  color: #fff;
`;
export const WalletStatusBox = styled(Box)`
  background: ${({ connected }) => 
    connected ? 'rgba(5, 223, 114, 0.1)' : 'rgba(255, 255, 255, 0.03)'};
  border: 1px solid ${({ connected }) => 
    connected ? 'rgba(5, 223, 114, 0.3)' : '#1f1f2e'};
  border-radius: 12px;
  padding: 20px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const Card2 = styled(Box)`
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
  padding: 24px;
  border: 1px solid #1f1f2e;
  width: 100%;
  margin-top: 30px;
  backdrop-filter: blur(10px);
`;

export const ConnectedWalletCard = styled.div`
  background: rgba(15, 8, 26, 0.6);
  border: 1px solid #1f1f2e;
  border-radius: 16px;
  padding: 20px;
  margin-top: 16px;
`;

export const WalletHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`;

export const WalletIconWrapper = styled.div`
  width: 58px;
  height: 58px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 8px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const WalletHeaderText = styled.div`
  flex: 1;
`;

export const WalletTitle = styled.p`
  margin: 0;
  font-size: 16px;
  color: #fff;
  font-weight: 500;
`;

export const WalletStatusText = styled.p`
  margin: 4px 0 0 0;
  font-size: 14px;
  color: #99A1AF;
`;

export const ConnectedBox = styled.div`
  background: rgba(5, 223, 114, 0.08);
  border: 1px solid rgba(5, 223, 114, 0.3);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
`;

export const CheckIcon = styled.div`
  width: 20px;
  height: 20px;
  background: #05DF72;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  
  &::after {
    content: '✓';
    color: #000;
    font-size: 12px;
    font-weight: bold;
  }
`;

export const ConnectedText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #05DF72;
  font-weight: 600;
  flex: 1;
`;

export const AddressText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #D1D5DC;
  font-weight: 500;
`;

export const DisconnectBtn = styled.button`
  width: 100%;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 14px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: rgba(255, 107, 107, 0.4);
    background: rgba(255, 107, 107, 0.05);
    color: #ff6b6b;
  }
`;


export const PaymentDetailsCard = styled(Card2)`
  background: rgba(255, 255, 255, 0.05);
  margin-top: 20px;
`;

export const DetailRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  
  &:last-child {
    border-bottom: none;
  }
`;

export const DetailLabel = styled.span`
  font-size: 14px;
  color: #99A1AF;
`;

export const DetailValue = styled.span`
  font-size: 14px;
  color: #fff;
  font-weight: 500;
`;

export const ConnectedBadge = styled(Box)`
  display: flex;
  align-items: center;
  gap: 6px;
  background: rgba(5, 223, 114, 0.15);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  color: #05DF72;
  font-weight: 600;
`;

export const GradientHeadingSpan = styled.span`
  background: linear-gradient(149deg, #fff 33%, #a860ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: bold;
`;

export const Card = styled(Box)`
  background: #080411;
  border-radius: 20px;
  padding: 24px;
  border: 1px solid #1f1f2e;
  width: 100%;
  margin-top: ${({ marginTop }) => marginTop || 0};
  backdrop-filter: blur(10px);
`;



// Important Card Styles
export const ImportantCard = styled(Box)`
  background: rgba(255, 52, 7, 0.08);
  border: 1px solid rgba(255, 52, 7, 0.08);
  border-radius: 12px;
  padding: 20px;
  margin-top: 30px;
  backdrop-filter: blur(10px);
`;

export const ImportantHeader = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
`;

export const ImportantTitle = styled.p`
  margin: 0;
  font-size: 16px;
  color: #E37905;
  letter-spacing: 0.3px;
`;

export const ImportantList = styled.ul`
  margin: 0;
  padding-left: 20px;
  color: #fff;
`;

export const ImportantListItem = styled.li`
  margin-bottom: 8px;
  font-size: 14px;
  line-height: 1.5;
  color: #fff;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const TabsWrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  gap: 16px;
`;

export const Tab = styled(Box)`
  width: 100%;
  padding: 16px 22px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 12px;
  margin-bottom: 40px;
  cursor: pointer;
  transition: all 0.25s ease-in-out;
  backdrop-filter: blur(4px);

  background: ${({ active }) =>
    active ? 'rgba(168, 96, 255, 0.12)' : 'rgba(255, 255, 255, 0.03)'};

  border: 1px solid
    ${({ active }) =>
      active ? 'rgba(168, 96, 255, 0.6)' : 'rgba(255, 255, 255, 0.08)'};

  box-shadow: ${({ active }) =>
    active ? '0 0 12px rgba(168, 96, 255, 0.45)' : 'none'};

  &:hover {
    border-color: rgba(168, 96, 255, 0.4);
    transform: translateY(-1px);
  }
`;

export const TabLabel = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: 500;
  color: ${({ active }) => (active ? '#CBA3FF' : '#A3A3B5')};
  letter-spacing: 0.3px;
`;

// Custom Select Styles
export const SelectWrapper = styled.div`
  position: relative;
  width: 100%;
  margin-top: 12px;
`;

export const SelectButton = styled.button`
  width: 100%;
  padding: 16px 20px;
  background: transparent;
  border-radius: 12px;
  border: 0.833px solid var(--stroke, #B892ED); 
  border-bottom: 0.833px solid #7300ffa2;
  border-left:0.833px solid #7300ffa2;
  border-right: 0.833px solid #7300ffa2;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s ease;
  backdrop-filter: blur(4px);

  &:hover {
    box-shadow: 0 0 12px rgba(168, 96, 255, 0.3);
  }

  &:focus {
    outline: none;
    border-color: rgba(168, 96, 255, 0.8);
    border-bottom-color: #7300FF; 
    box-shadow: 0 0 16px rgba(168, 96, 255, 0.4);
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: #1a0a2e76;
  border: 1px solid rgba(168, 96, 255, 0.4);
  border-radius: 12px;
  margin-top: 8px;
  z-index: 1000;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(32px);
  animation: dropdownAppear 0.2s ease-out;

  @keyframes dropdownAppear {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const Option = styled.div`
  padding: 16px 20px;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(168, 96, 255, 0.1);
  font-weight: 500;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background: rgba(168, 96, 255, 0.15);
    color: #CBA3FF;
  }
  
  ${({ selected }) =>
    selected &&
    `
    background: rgba(168, 96, 255, 0.2);
    color: #CBA3FF;
    font-weight: 600;
  `}
`;

export const ArrowIconWrapper = styled(KeyboardArrowDown)`
  transition: all 0.3s ease;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0)')};
  color: #A860FF;
  font-size: 20px;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: transparent;
`;

export const StyledButton = styled(Button)`
  text-transform: none;
  color: white;
  font-family: "PoppinsM";
  width: 100%;
  border-radius: 40px !important;
  font-size: 16px;
  font-family: Bold !important;
  padding: ${(props) => (props.p ? props.p : "6px 20px")};
  border: 3px solid #220154;

  &:hover {
    background: linear-gradient(90deg, #7300FF 0%, #B892ED 100%);
    color: white;
  }
  &:disabled {

    cursor: not-allowed;
  }
  @media(max-width: 599px) {
    font-size: 14px !important;
    padding: 7px 9px !important;
  }
`;

export const UpperBox = styled(Box)`
  background: linear-gradient(90deg, #7300FF 0%, #B892ED 100%);
  padding: 2px;
  border-radius: 40px;
  width: 100%;
`;

export const WalletGrid = styled(Grid)`
`;

export const WalletItem = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border-radius: 8px;
  gap: 10px;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
  border: 1px solid #1f1f2e;

  &:hover {
    border-color: rgba(168, 96, 255, 0.4);
    background: rgba(168, 96, 255, 0.05);
    transform: translateY(-2px);
  }
`;

export const WalletIcon = styled.img`
  width: 28px;
  height: 28px;
  @media (max-width: 599px) {
    width: 20px;
    height: 20px;
  }
`;

export const WalletName = styled.p`
  margin: 0;
  font-size: 12px;
  color: #D1D5DC;
  text-align: center;
  font-weight: 500;

  @media (max-width: 599px) {
    font-size: 11px;
  }
`;
export const WalletIconBox = styled(Box)`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 18px;
`;
export const CardFormWrapper = styled.div`
  /* margin-top: 24px; */
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 14px;
  color: #D1D5DC;
  margin-bottom: 8px;
  font-weight: 500;
`;

export const InputField = styled.input`
  width: 100%;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid #2b2b3d;
  border-radius: 12px;
  color: #fff;
  font-size: 15px;
  transition: all 0.3s ease;
  
  &::placeholder {
    color: #6B7280;
  }
  
  &:focus {
    outline: none;
    border-color: #7300FF;
    background: rgba(115, 0, 255, 0.05);
  }
  
  &:hover {
    border-color: rgba(168, 96, 255, 0.4);
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
`;

export const SecurePaymentBox = styled.div`
  background: rgba(59, 130, 246, 0.08);
  border: 1px solid rgba(59, 130, 246, 0.3);
  border-radius: 12px;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
    align-items: flex-start;
  gap: 10px;
  margin-top: 20px;
`;

export const SecureIcon = styled.div`
  width: 23px;
  height: 23px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
`;

export const SecureText = styled.p`
  margin: 0;
  font-size: 13px;
  color: #93C5FD;
  line-height: 1.5;
`;

export const PaymentDetailsBox = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid #1f1f2e;
  border-radius: 12px;
  padding: 20px;
  margin-top: 24px;
`;

export const PaymentDetailsTitle = styled.p`
  margin: 0 0 16px 0;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
`;

export const AmountRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AmountLabel = styled.span`
  font-size: 14px;
  color: #99A1AF;
`;

export const AmountValue = styled.span`
  font-size: 18px;
  color: #fff;
  font-weight: 600;
`;